import { useEffect } from 'react'
import { useRouter } from 'next/router'

import { Spinner } from '@wartek-id/spinner'

import { useAPIKinerjaProfile } from 'api/kinerja/useAPIKinerja'
import PanelProfil from 'app/KinerjaPage/components/PanelProfil'

import type { Kinerja, KinerjaTeachingRoleType } from 'types/kinerja'

export default function KonfirmasiProfil({
  skp,
  isSKPFetched,
  isSKPLoading,
  skipEditConfirmation = false,
  role = 'GURU',
}: {
  skp: Kinerja
  isSKPFetched: boolean
  isSKPLoading: boolean
  skipEditConfirmation?: boolean
  role?: KinerjaTeachingRoleType
}) {
  const router = useRouter()
  const {
    data: profile,
    isFetched: isProfileFetched,
    isLoading: isProfileLoading,
  } = useAPIKinerjaProfile()

  useEffect(() => {
    if (isSKPFetched && skp?.status !== 'NOT_FOUND') {
      router.push('/pengelolaan-kinerja')
    }
  }, [router, skp, isSKPFetched])

  if (isProfileLoading && isSKPLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner data-testid="loading-spinner" />
      </div>
    )
  }

  return (
    isProfileFetched &&
    skp?.status === 'NOT_FOUND' && (
      <div className="mt-5 pt-6">
        <PanelProfil
          profile={profile.data}
          role={role}
          skipEditConfirmation={skipEditConfirmation}
        />
      </div>
    )
  )
}
